import { render } from "./FolderSemesterForm.vue?vue&type=template&id=806bc9ae"
import script from "./FolderSemesterForm.vue?vue&type=script&lang=js"
export * from "./FolderSemesterForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__